<!--
 * @Author: cryi.liu
 * @Date: 2020-05-15 14:53:22
 * @LastEditTime: 2020-05-26 14:16:26
 * @Description: 单选或判断作答区域
-->
<template>
  <div class="single-choice">
    <i-radio-group v-model="value" size="small" vertical @on-change="singleChoiceSlectChanged">
      <i-radio v-for="option in options" :key="option.id" :label="option.id">
        <span>{{ option.content }}</span>
      </i-radio>
    </i-radio-group>
  </div>
</template>

<script>
export default {
  name: 'SingleChoice',
  props: {
    options: { type: Array, required: true },
  },
  data() {
    return {
      value: '',
    };
  },
  watch: {
    options: {
      immediate: true,
      handler(options) {
        options.forEach((option) => {
          if (option.correct) {
            this.value = option.id;
          }
        });
      },
    },
  },
  methods: {
    /**
     * 单项选择发生改变
     */
    singleChoiceSlectChanged(value) {
      this.$emit('select-change', value);
    },
  },
};
</script>

<style lang="less" scoped>
.single-choice {
  width: 100%;

  /deep/ .ivu-radio-group {
    .ivu-radio-wrapper {
      font-size: 12px;

      .ivu-radio {
        margin-right: 8px;
      }

      .ivu-radio-disabled .ivu-radio-inner:after {
        background-color: #2d8cf0;
      }
    }
  }
}
</style>
